const _display = ["var(--font-display)"]
const _body = ["var(--font-body)"]
const _button = ["var(--font-button)"]
const config = { "display": _display, "body": _body, "button": _button, "display-hero": ["var(--font-display-hero)"],  }
export { config as default, _display, _body, _button }